module.exports = __webpack_public_path__ + "static/media/IMG_20180203_103030.6e31b9cf.jpg";